// extracted by mini-css-extract-plugin
export var aboutValuesContainer = "AboutValues-module--aboutValuesContainer--g1HOA";
export var aboutValue1 = "AboutValues-module--aboutValue1--gEgKE";
export var aboutValue2 = "AboutValues-module--aboutValue2--OkfNY";
export var image = "AboutValues-module--image--rCL7H";